import Dropzone, { IDropzoneProps } from './Dropzone';

export default Dropzone;
export type { IDropzoneProps };
